import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const exportApiRoutes = {
    list: apiDataManagerBaseURL + "export",
    export: apiDataManagerBaseURL + "export"
};


export class ExportAPI {
    constructor() {
        this.baseUrl = new URL("export/", apiDataManagerBaseURL);
    }

    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? exportApiRoutes.list : `${exportApiRoutes.list}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static export(model, provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? exportApiRoutes.export : `${exportApiRoutes.export}?providerId=${provider}`,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(model)
        });
    }
}
